import React from 'react';
import { NavLink } from 'react-router-dom';

const Navigation: React.FC = () => {
  const linkClassName = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap rounded-md px-1.5 py-1.5 text-[11px] transition-colors duration-200 sm:px-2.5 sm:py-2 sm:text-base ${
      isActive ? 'bg-gray-200 text-black' : 'text-black hover:bg-gray-100'
    }`;

  return (
    <nav aria-label="Primary navigation" className="flex w-full items-center justify-between gap-0.5 rounded-lg bg-white bg-opacity-70 p-1 backdrop-blur-lg sm:w-auto sm:justify-start sm:gap-2 sm:p-2">
      <NavLink to="/projects" className={linkClassName}>Research</NavLink>
      <NavLink to="/consultation" className={linkClassName}>Consultation</NavLink>
      <NavLink to="/resources" className={linkClassName}>Resources</NavLink>
      <NavLink
        to="/contact"
        className="whitespace-nowrap rounded-md bg-black px-1.5 py-1.5 text-[11px] text-white transition-colors duration-200 hover:bg-gray-800 sm:px-4 sm:py-2 sm:text-base"
      >
        Get in touch
      </NavLink>
    </nav>
  );
};

export default Navigation;
